import type {
  ImageModelsRefreshResponse,
  ImageModelsResponse,
  SaveAlphaSettingsBody,
  SaveImageModelsBody,
} from "@nlc/shared-types";

import {
  imageModelsRefreshResponseZod,
  imageModelsResponseZod,
} from "@nlc/shared-types";

import { MBC_AI_API_URL } from "@/features/request/mbc-review/config";

import { aiRequest } from "./aiCosts.api";

const MODELS_URL = `${MBC_AI_API_URL}/usage/models`;

function jsonBody(method: "POST" | "PUT", body?: unknown): RequestInit {
  return {
    body: body === undefined ? undefined : JSON.stringify(body),
    headers: { "Content-Type": "application/json" },
    method,
  };
}

export async function getImageModels(): Promise<ImageModelsResponse> {
  return imageModelsResponseZod.parse(await aiRequest(MODELS_URL));
}

export async function saveImageModels(
  body: SaveImageModelsBody,
): Promise<ImageModelsResponse> {
  return imageModelsResponseZod.parse(
    await aiRequest(MODELS_URL, jsonBody("PUT", body)),
  );
}

export async function saveAlphaSettings(
  body: SaveAlphaSettingsBody,
): Promise<ImageModelsResponse> {
  return imageModelsResponseZod.parse(
    await aiRequest(`${MBC_AI_API_URL}/alpha/settings`, jsonBody("PUT", body)),
  );
}

export async function refreshImageModels(): Promise<ImageModelsRefreshResponse> {
  return imageModelsRefreshResponseZod.parse(
    await aiRequest(`${MODELS_URL}/refresh`, jsonBody("POST")),
  );
}
